type Props = {
  margin?: string;
  children: React.ReactNode;
};

const LayoutGameBackground = ({ margin, children }: Props) => {
  return <div className={`l-game-background ${margin ? margin : ''}`}>{children}</div>;
};

export default LayoutGameBackground;
